import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Link from 'next/link';

// Extract the hash (if any) from a react-router `to` prop, which can be either a
// string ("/path#section") or a location-like object ({ pathname, hash }).
const hasHashTarget = to => {
  if (typeof to === 'string') return to.includes('#');
  if (to && typeof to === 'object') return Boolean(to.hash);
  return false;
};
const LinkMock = React.forwardRef(function NextInnerLink(props, ref) {
  const $ = _c(9);
  let rest;
  let scroll;
  let to;
  if ($[0] !== props) {
    ({
      to,
      scroll,
      ...rest
    } = props);
    $[0] = props;
    $[1] = rest;
    $[2] = scroll;
    $[3] = to;
  } else {
    rest = $[1];
    scroll = $[2];
    to = $[3];
  }
  const resolvedScroll = scroll ?? (hasHashTarget(to) ? undefined : false);
  let t0;
  if ($[4] !== ref || $[5] !== resolvedScroll || $[6] !== rest || $[7] !== to) {
    t0 = <Link {...rest} scroll={resolvedScroll} href={to} ref={ref} />;
    $[4] = ref;
    $[5] = resolvedScroll;
    $[6] = rest;
    $[7] = to;
    $[8] = t0;
  } else {
    t0 = $[8];
  }
  return t0;
});
export default LinkMock;